import { isPresentationProject } from "../../utils/presentationMode";

const PresentationModeBadge = ({ project }) => {
  if (!isPresentationProject(project)) return null;

  return (
    <span
      className="presentation-mode-badge"
      title="Esta obra é estática e não aceita edições nem atualizações"
    >
      Obra de apresentação · somente leitura
    </span>
  );
};

export default PresentationModeBadge;
